<template>
  <div>
    <tk-flex between >
      <public-header title="用户反馈" show-back></public-header>
      <a-button v-if="can('replyMsgRecordModel')" type="primary" @click="areaModal = true" >
        回复
      </a-button>
    </tk-flex>

    <!-- 订单反馈 -->
    <div v-if="list.length">
      <div v-for="(t, i) in list" :key="i" class="p-15 m-b-20" style="background-color: #fff;border-radius: 12px;" >
        <tk-flex middle >
          <tk-image v-if="t.type === 'user' && t._User.avatar" :src="t._User.avatar" :width="32" :height="32" size="contain" style="border-radius: 50%;"></tk-image>
          <tk-flex v-else middle center style="width: 32px;height: 32px;border-radius: 50%;background: linear-gradient(159deg, #FF2A58 1%, #FF3940 92%);" >
            <tk-icon style="margin-top: 0px;" :size="16" :color="'#fff'" >tianneng</tk-icon>
          </tk-flex>
          <div class="m-l-8">
            <div class="font-14 font-bold" >{{ t.type === 'user' ? t._User.nickName : '天能电池' }}</div>
            <div class="font-12" style="color: #8A92A1" >{{ t.createdAt | date }}</div>
          </div>
        </tk-flex>
        <div class="font-13 m-t-10" style="color: #6A7280;word-break: break-all;" >{{ t.content }}</div>
      </div>
    </div>

    <Reply v-if="areaModal" :record="pageData" @complete="areaModal = false" ></Reply>

  </div>
</template>
<script>
import gql from 'graphql-tag'
import Reply from '../../core/component/msg/reply.vue'
import publicHeader from '../../components/publicHeader.vue'
export default {
  components: {
    publicHeader,
    Reply
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      areaModal: false, // 弹框
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        const { data } = await this.$tkParse.get(`/classes/dialogue/${this.$route.query.id}`)
        this.noticeSubscription()
        this.pageData = data
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    // 设置已读
    async setRead () {
      try {
        await this.$tkParse.put(`/classes/dialogue/${this.$route.query.id}`, {
          isRead: true
        })
      } catch (error) {
        console.log(error)
      }
    },
    // 新通知监听
    noticeSubscription () {
      this.$apollo.addSmartSubscription('msgRecord', {
        query: gql`subscription MySubscription($dialogue: bpchar = "") {
          msgRecord(where: {dialogue: {_eq: $dialogue}}, order_by: {createdAt: asc}, limit: 100) {
            objectId
            content
            user
            createdAt
            type
            _User {
              nickName
              avatar
              objectId
            }
          }
        }`,
        variables () {
          return {
            dialogue: this.$route.query.id
          }
        },
        result ({ data: res }) {
          console.log(res)
          this.list = res.msgRecord
          this.setRead()
        },
        fetchPolicy: 'no-cache' // 解决缓存问题
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
